import {
  // -- GET (list)
  // GET_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS,
  // GET_FLOW_TASK_INTERACTION_RESOURCE_FAILURE,
  // -- CREATE
  CREATE_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS,
  CREATE_FLOW_TASK_INTERACTION_RESOURCE_FAILURE,
  // -- UPDATE
  UPDATE_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS,
  UPDATE_FLOW_TASK_INTERACTION_RESOURCE_FAILURE,
  // -- DELETE
  DELETE_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS,
  DELETE_FLOW_TASK_INTERACTION_RESOURCE_FAILURE
} from '../../actions'
import { Logger, LoggerTypes } from '../../utils'

export const flowTaskInteractionResources = (state = {}, action) => {
  switch (action.type) {
    // -- GET (list)
    // case GET_FLOW_TASK_INTERACTION_RESOURCE_FAILURE: {
    //   Logger.trace(
    //     LoggerTypes.WARN,
    //     '[REDUCER] flowTaskInteractionResources.GET_FLOW_TASK_INTERACTION_RESOURCE_FAILURE()',
    //     { state, error: action.data }
    //   )
    //   return { ...state, error: action.data }
    // }
    // case GET_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS: {
    //   Logger.trace(
    //     LoggerTypes.REDUCER,
    //     '[REDUCER] flowTaskInteractionResources.GET_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS()',
    //     {
    //       state,
    //       action
    //     }
    //   )

    //   return {
    //     ...state,
    //     ...action.data
    //   }
    // }

    // -- CREATE
    case CREATE_FLOW_TASK_INTERACTION_RESOURCE_FAILURE: {
      Logger.trace(
        LoggerTypes.WARN,
        '[REDUCER] flowTaskInteractionResources.CREATE_FLOW_TASK_INTERACTION_RESOURCE_FAILURE()',
        { state, error: action.data }
      )
      return { ...state, error: action.data }
    }
    case CREATE_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS: {
      Logger.trace(
        LoggerTypes.REDUCER,
        '[REDUCER] flowTaskInteractionResources.CREATE_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS()',
        {
          state,
          action
        }
      )

      return {
        ...state,
        ...action.data
      }
    }

    // -- UPDATE
    case UPDATE_FLOW_TASK_INTERACTION_RESOURCE_FAILURE: {
      Logger.trace(
        LoggerTypes.WARN,
        '[REDUCER] flowTaskInteractionResources.UPDATE_FLOW_TASK_INTERACTION_RESOURCE_FAILURE()',
        { state, action }
      )
      return { ...state, error: action.data }
    }
    case UPDATE_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS: {
      Logger.trace(
        LoggerTypes.REDUCER,
        '[REDUCER] flowTaskInteractionResources.UPDATE_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS()',
        { state, action }
      )

      return {
        ...state,
        ...action.data
      }
    }

    // -- DELETE
    case DELETE_FLOW_TASK_INTERACTION_RESOURCE_FAILURE: {
      Logger.trace(
        LoggerTypes.WARN,
        '[REDUCER] flowTaskInteractionResources.DELETE_FLOW_TASK_INTERACTION_RESOURCE_FAILURE()',
        { state, error: action.data }
      )
      return { ...state, error: action.data }
    }
    case DELETE_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS: {
      Logger.trace(
        LoggerTypes.REDUCER,
        '[REDUCER] flowTaskInteractionResources.DELETE_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS()',
        {
          state,
          action
        }
      )

      return {
        ...state,
        ...action.data
      }
    }

    default:
      return state
  }
}
